import React, { useEffect } from 'react';
import { Disconnect } from './components/Disconnect';
import Cookies from 'js-cookie';

export const DisconnectHandler = ({
  logoutHandler,
  logoutDelay,
  accessToken,
  location,
  userId,
  getUser,
  domainValue,
  refreshTokenHandler,
}) => {
  const disconnect = () => {
    Cookies.remove('last_active', {
      domain: domainValue,
    });
    logoutHandler();
  };

  const checkAuthCookiesChange = (cookies, prevCookies) => {
    const oldAccessToken = prevCookies.includes('access_token');
    const newAccessToken = cookies.includes('access_token');
    const oldUserId = prevCookies.includes('userId');
    const newUserId = cookies.includes('userId');

    // If auth cookies are removed - disconnect
    if ((oldUserId && !newUserId) || (oldAccessToken && !newAccessToken)) {
      disconnect();
      return;
    }

    // If auth cookies changed (but not removed) - refresh user data
    if (oldAccessToken !== newAccessToken || oldUserId !== newUserId) {
      getUser();
    }
  };

  const checkCookies = (() => {
    let lastCookie = document.cookie;

    return () => {
      const currentCookie = document.cookie;

      if (currentCookie !== lastCookie) {
        checkAuthCookiesChange(currentCookie, lastCookie);

        lastCookie = currentCookie;
      }
    };
  })();

  const checkRefreshToken = (() => () => {
    refreshTokenHandler();
  })();

  useEffect(() => {
    const interval = setInterval(() => checkCookies(), 3000);
    const intervalRefresh = setInterval(() => checkRefreshToken(), 10000);

    return () => {
      clearInterval(interval);
      clearInterval(intervalRefresh);
    };
  }, []);

  return (
    <Disconnect
      location={location}
      userId={userId}
      logoutHandler={disconnect}
      accessToken={accessToken}
      logoutDelay={logoutDelay}
      getUser={getUser}
      domainValue={domainValue}
    />
  );
};
